import { useEffect } from "react";
import type { Dispatch } from "react";
import { useLocation } from "react-router-dom";
import { useSidebarContext, ACTIONS } from "./context";
import type { SidebarAction } from "./context/types";

type SidebarLocationAction =
  | "openSidebar"
  | "preventCollapse"
  | "collapseSidebar";

type SidebarLocationState = {
  sidebar?: {
    action: SidebarLocationAction;
    selectedTab?: string | null;
  };
};

const perfromSidebarAction = (
  dispatch: Dispatch<SidebarAction>,
  locationState: unknown
) => {
  // sidebar command sent via router state
  const sidebar = (locationState as SidebarLocationState | undefined)?.sidebar;
  if (sidebar) {
    if (sidebar.action === "openSidebar") {
      dispatch({
        type: ACTIONS.SELECT_SIDEBAR_TAB,
        selectedTab: sidebar.selectedTab ?? null,
      });
      return true;
    }
    if (sidebar.action === "preventCollapse") {
      // do nothing
      return true;
    }
    if (sidebar.action === "collapseSidebar") {
      dispatch({
        type: ACTIONS.SELECT_SIDEBAR_TAB,
        selectedTab: null,
      });
      return true;
    }
  }

  // Remove the default collapse behavior
  return false;
};

const useLocationSidebarEffects = () => {
  const location = useLocation();
  const [, dispatch] = useSidebarContext();

  useEffect(() => {
    perfromSidebarAction(dispatch, location.state);
    // TODO: original deps array also included `location.path`, which does
    // not exist on the react-router `Location` type (it's `pathname`) and
    // was therefore always `undefined` - dropped here since it can never
    // have changed the effect's behavior.
  }, [dispatch, location.state]);

  return null;
};

export default useLocationSidebarEffects;
